import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=b70a0bee&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b70a0bee')) {
      api.createRecord('b70a0bee', component.options)
    } else {
      api.reload('b70a0bee', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=b70a0bee&", function () {
      api.rerender('b70a0bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nnrJQgp8g5lq/JS/comp/ErrorMessage.vue"
export default component.exports